// Component
// import RegisterMode from "./modeMore/index";
import RegisterMode from "./modeSingle/index";

export default function RegisterApp(props) {

    return <RegisterMode {...props}></RegisterMode>;
}